import { ComponentPropsWithoutRef } from 'react';

export const SingleDotIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 5 6" fill="none">
      <circle cx="2.5" cy="3" r="2.5" fill="#000000" />
    </svg>
  );
};
